import { render } from "./accountMenu.vue?vue&type=template&id=bd44a318&scoped=true"
import script from "./accountMenu.vue?vue&type=script&lang=js"
export * from "./accountMenu.vue?vue&type=script&lang=js"

import "./accountMenu.vue?vue&type=style&index=0&id=bd44a318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd44a318"]])

export default __exports__